import { axiosInstance } from 'network/apis';

function getAllCards(payload) {
    return axiosInstance.post(`/api/v1/giftcards/getAllProducts`, payload);
}

function getWalletBalance(payload) {
    return axiosInstance.post(`/api/v1/profiles/getProfileBalance`, payload);
}

function getAllUsers(payload) {
    return axiosInstance.post(`/api/v1/profiles/getAllUsers`, payload);
}

function postGiftCard(payload) {
    return axiosInstance.post(`/api/v1/gift-card/place-order`, payload);
}

export { getAllCards, getWalletBalance, getAllUsers, postGiftCard };
